// extracted by mini-css-extract-plugin
module.exports = {"blog-metadata":"blog_blog-metadata__neXlh","list":"blog_list__ja_5N","datetime":"blog_datetime__4o5g4"};